import { useTimezone } from '@app/core/hooks/useTimezone';
import { useTzFormat } from '@app/core/hooks/useTzFormat';
import { DateStr, toDateRange } from '@mi-front/core';
import { GipReportValues } from '../types';

/** Default GIP form values; "today" is computed in the active timezone. */
export function useGipReportDefaultValues(data: Partial<GipReportValues> = {}): GipReportValues {
  const tz = useTimezone();
  const formatTz = useTzFormat();
  const { from, to } = toDateRange(formatTz(new Date(), 'YYYY-MM-DD') as DateStr, tz);

  return {
    from,
    to,
    stationsSelectionType: 'advanced',
    stations: [],
    stationsFilter: [],
    advertisers: [],
    campaigns: [],
    versions: [],
    customFieldKey: null,
    customFieldValue: '',
    customIds: [],
    orders: [],
    excludedMatches: [],
    ...data,
  };
}
